import { isNaNNumber, trueSet } from "@/utils/pureFunctions";

export default (table) => {
  return {
    data() {
      return {
        dataHeaders: [],
        visibleHeaders: [],
        cachingOpenedItem: {},
      };
    },
    computed: {
      headers: function () {
        return this.dataHeaders.map((item, index) => {
          return {
            text: this.$t(item.columnLabel),
            sortable: item.sortable,
            value: item.columnName,
            index,
            style: {
              minWidth: isNaNNumber(item.minWidth)
                ? item.minWidth
                : parseInt(item.minWidth) + "px",
            },
          };
        });
      },
    },
    methods: {
      $toggleShowHandler(id, opened) {
        if (opened) {
          this.$set(this.cachingOpenedItem, id, id);
        } else {
          this.$delete(this.cachingOpenedItem, id);
        }
      },
      onChangeSizeHeader({ key, width }) {
        this.$http
          .post("column-settings/current-user/update", {
            columnName: key,
            width,
            table: "_Order",
          })
          .catch((err) => this.setResponseError({ error: err }));
      },
      async changeColumnSettings(item, attr) {
        try {
          await this.$store.dispatch("updateColumn", {
            columnName: item.value,
            table,
            visible: !trueSet(attr["aria-selected"]),
          });
        } catch (e) {
          this.setResponseError({ error: e });
        }
      },
      onChangeHeaderOrder({ currentIndex, oldIndex }) {
        let headers = [...this.dataHeaders];
        const header = this.dataHeaders[oldIndex];
        headers.splice(oldIndex, 1);
        headers.splice(currentIndex, 0, header);
        this.$http
          .post("column-settings/sort", {
            index: currentIndex,
            table,
            columnName: this.dataHeaders[oldIndex].columnName,
          })
          .catch((e) => this.setResponseError({ error: e }));
        this.dataHeaders = headers;
      },
      async getColumns() {
        try {
          const data = await this.$store.dispatch("getColumns", table);
          const visibleHeaders = [];
          data.forEach((item) => {
            if (item.visible) {
              visibleHeaders.push(item.columnName);
            }
          });
          this.dataHeaders = data;
          this.visibleHeaders = visibleHeaders;
        } catch (e) {
          this.setResponseError({ error: e });
        }
      },
    },
  };
};
